const types = {
  VALIDATE_ZIPCODE: '@@IO_PREFERENCES/VALIDATE_ZIPCODE',
  FETCH_ZIP_CODE: '@@IO_PREFERENCES/FETCH_ZIP_CODE',
  GET_INSURANCE_LIST: '@@IO_PREFERENCES/GET_INSURANCE_LIST',
  GET_CLINICIANS_COUNT: '@@IO_PREFERENCES/GET_CLINICIANS_COUNT',
  GET_CLINICIANS_VALID: '@@IO_PREFERENCES/GET_CLINICIANS_VALID',
};

export default types;
